var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.572,
    height: 16.556,
    viewBox: "0 0 18.572 16.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(0.001 -27.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1852",
    "data-name": "Group 1852",
    transform: "translate(-0.001 27.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1851",
    "data-name": "Group 1851",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M18.374,34.337l-8.8-6.446a.482.482,0,0,0-.57,0L.2,34.337a.483.483,0,1,0,.57.779l8.518-6.237L17.8,35.115a.483.483,0,0,0,.57-.779Z",
    transform: "translate(0.001 -27.798)",
    fill: "gray"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1854",
    "data-name": "Group 1854",
    transform: "translate(2.047 35.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1853",
    "data-name": "Group 1853",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M70.446,232.543a.483.483,0,0,0-.483.483v7.681H66.1v-4.193a2.413,2.413,0,0,0-4.826,0v4.193h-3.86v-7.681a.483.483,0,0,0-.965,0v8.164a.483.483,0,0,0,.483.483H61.76a.482.482,0,0,0,.481-.445.364.364,0,0,0,0-.038v-4.675a1.448,1.448,0,0,1,2.9,0v4.675a.354.354,0,0,0,0,.037.482.482,0,0,0,.481.445h4.826a.483.483,0,0,0,.483-.483v-8.164A.483.483,0,0,0,70.446,232.543Z",
    transform: "translate(-56.452 -232.543)",
    fill: "gray"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b2b0a663fa8f40e73f0ebc2592db55b3.svg";
export { ForwardRef as ReactComponent };